export function SavedJobsPage() {
  return (
    <div>
      <h1 className="text-2xl font-semibold text-gray-900">Saved Jobs</h1>
      <p className="mt-2 text-gray-600">Jobs you've saved for later</p>
      {/* Saved jobs implementation will go here */}
    </div>
  );
}